import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './styles/main.css'
import './styles/lightside.css'
import './styles/darkside.css'
import Vuelidate from 'vuelidate'
import VueChatScroll from 'vue-chat-scroll'
import LoadScript from 'vue-plugin-load-script'
import VModal from 'vue-js-modal'

import 'vue-draggable-resizable/dist/VueDraggableResizable.css'
import 'animate.css'

Vue.use(VModal)
Vue.use(Vuelidate)
Vue.use(VueChatScroll)
Vue.use(LoadScript)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
